// extracted by mini-css-extract-plugin
export default {"button":"button_button__VWeAX","primary":"button_primary__z0bfb","danger":"button_danger__5NRM5","secondary":"button_secondary__ayf5o","item":"button_item__UToe7"};